// extracted by css-extract-rspack-plugin
export default {"root":"wGcAK","headerContent":"pwUQ7","resizeHandle":"mnyW9"};